import { Type } from "class-transformer";
import { GenericDataType } from "src/modules/enaio/shared/GenericDataType";
import { SmErrorHandler } from "src/modules/sm-base/misc/sm-error-handler";
import { TableCellType } from "src/modules/sm-base/models/table-cell-type.enum";
import { Utils } from "src/modules/utils/shared/utils";

export class EnaioFrontendColumn {
    title = "";
    source = "";
    @Type(() => String)
    selectFields: string[] = [];
    @Type(() => String)
    selectFieldsParent: string[] = [];
    type: GenericDataType;

    constructor(title: string) {
        this.title = title;
      //  this.source = source;
    }

    toTableCellType(): TableCellType {
        switch (this.type) {
            case GenericDataType.string:
                return TableCellType.text;
            case GenericDataType.int:
                return TableCellType.int;
            case GenericDataType.decimal:
                return TableCellType.decimal;
            case GenericDataType.bool:
                return TableCellType.yesNo;
            case GenericDataType.date:
                return TableCellType.date;
            case GenericDataType.dateTime:
                return TableCellType.dateTime;
            default:
                throw new Error("Der GenericDataType " + this.type + " kann nicht zu TableCellType konvertiert werden");
        }
    }

    toTableValue(value: any): any {
        try {
            switch (this.type) {
                case GenericDataType.string:
                    return Utils.toString(value);
                case GenericDataType.int:
                    return value == "" ? "" : Utils.toNumber(value);
                case GenericDataType.decimal:
                    return value == "" ? "" : Utils.toNumber(value);
                case GenericDataType.bool:
                    return Utils.toBool(value);
                case GenericDataType.date:
                    return Utils.toDate(value);
                case GenericDataType.dateTime:
                    return Utils.toDate(value);
                default:
                    throw new Error("Der GenericDataType " + this.type + " kann nicht zu TableCellType konvertiert werden");
            }
        }
        catch (error) {
            SmErrorHandler.instance.handleError(error);
            return "";
        }
    }
}
